<template>
  <q-dialog v-model="small">
    <q-card style="width: 300px;">
      <q-card-section>
        <div class="text-indigo-5">{{ t('common.wrong') }}</div>
      </q-card-section>

      <q-card-section class="q-pt-none"> {{ errorMessage }} </q-card-section>

      <q-card-actions align="right" class="text-teal">
        <q-btn :class="!isVind ? 'orange-btn-filled' : ''" flat label="OK" @click="disableModal()" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, computed } from 'vue';
import store from '../../store/index';

export default {
  setup() {
    const errorMessage = computed({
      get: () => store.state.grantItems.modalErrorMessage,
    });

    const isModalActive = computed({
      get: () => store.state.grantItems.hasModalError,
    });

    const disableModal = () => {
      store.commit('grantItems/disableModalError');
    };

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });

    return {
      small: ref(isModalActive),
      errorMessage,
      isModalActive,
      isVind,
      disableModal,
    };
  },
};
</script>
